import { useTheme } from '@mui/material';

import { CRITERIA_CHIP_STYLES } from '../../../constants/previewChipStyles';
import { CriteriaViewCardProps } from '../CriteriaViewCard';
import { CriteriaStatusType } from '../types';

export const useCriteriaViewCard = (props: CriteriaViewCardProps) => {
  const { canMoveUp, canMoveDown, serialNumber, onMoveUp, onMoveDown } = props;

  const theme = useTheme();

  const getStatusColors = (
    status: CriteriaStatusType
  ): { backgroundColor: string; color: string } => {
    switch (status) {
      case CriteriaStatusType.INCLUSION:
        return CRITERIA_CHIP_STYLES.INCLUSION;

      case CriteriaStatusType.EXCLUSION:
        return CRITERIA_CHIP_STYLES.EXCLUSION;

      case CriteriaStatusType.INDEX_DATE:
        return CRITERIA_CHIP_STYLES.INDEX_DATE;

      case CriteriaStatusType.NOT_APPLIED:
        return CRITERIA_CHIP_STYLES.NOT_APPLIED;

      default:
        return { backgroundColor: theme.palette.grey[400], color: theme.palette.text.primary };
    }
  };

  const onMoveUpClick = () => canMoveUp && onMoveUp?.();
  const onMoveDownClick = () => canMoveDown && onMoveDown?.();

  const serialNumberValue = serialNumber?.toString().padStart(2, '0');

  return {
    getStatusColors,
    theme,
    onMoveUpClick,
    onMoveDownClick,
    serialNumberValue,
    ...props,
  };
};
